import React, { useState, useRef, useEffect } from "react";
import TabComponent from "./TabComponent.js";
import ReactHtmlParser from "html-react-parser";

const ServiceDetail = ({ service }) => {
  const [showFullContent, setShowFullContent] = useState(false);
  const [showButton, setShowButton] = useState(false);
  const contentRef = useRef(null);

  useEffect(() => {
    if (contentRef.current) {
      const contentHeight = contentRef.current.clientHeight;
      if (contentHeight > 290 /* Change to your desired height */) {
        setShowButton(true);
      }
    }
  }, []);

  const toggleFullContent = () => {
    setShowFullContent(true);
    setShowButton(false);
  };

  return (
    <div className="service-detail">
      <h2 className="service-detail-header">
        {service.attributes.service_name}
      </h2>
      <div
        className={`service-detail-content ${
          showFullContent ? "full-content" : ""
        }`}
        ref={contentRef}
      >
        {ReactHtmlParser(service.attributes.service_detail)}
      </div>
      {showButton && (
        <button className="read-more-button" onClick={toggleFullContent}>
          Read More
        </button>
      )}
      {service.attributes.service_tabs.data.length !== 0 && (
        <div className="service-tab" style={{ display: "flex" }}>
          <TabComponent data={service.attributes.service_tabs.data} />
        </div>
      )}
    </div>
  );
};

export default ServiceDetail;
